module.exports = __webpack_public_path__ + "img/conductivity.726314df.png";